import { FileBraces } from "lucide-react";
import React, { useMemo } from "react";

import { InjectionMod } from "@src/store/slices/experienceBuilder/types";
import { ModificationListItem } from "@src/features/experienceBuilder/modifications/common/ModificationListItem";

export const InjectionListItem = ({ mod }: { mod: InjectionMod }) => {
  const subtitle = useSubtitle(mod);
  return (
    <ModificationListItem
      mod={mod}
      icon={<FileBraces size={16} />}
      title={"CSS/JS modification"}
      subtitle={subtitle}
    />
  );
};

function useSubtitle(mod: InjectionMod) {
  return useMemo(() => {
    if (mod.description) {
      return mod.description;
    }

    const parts: string[] = [];
    if (mod.css) {
      parts.push("CSS edit");
    }
    if (mod.js) {
      parts.push("JS edit");
    }
    return parts.join(", ");
  }, [mod]);
}
